export type AttributionIdentifiers = {
  readonly fbclid?: string;
  readonly fbp?: string;
  readonly fbc?: string;

  readonly gclid?: string;
  readonly gbraid?: string;
  readonly wbraid?: string;
  readonly ga?: string;
  readonly gid?: string;
  readonly gclAu?: string;

  readonly ttclid?: string;
  readonly ttp?: string;

  readonly msclkid?: string;
  readonly liFatId?: string;
  readonly epik?: string;

  readonly customClickIds?: Readonly<Record<string, string>>;

  readonly firstCollectedAt?: number;
  readonly lastCollectedAt?: number;
  readonly landingUrl?: string;
  readonly referrer?: string;
};

export type AttributionConfig = {
  readonly enabled: boolean;
  readonly ttlDays?: number;
  readonly persist?: boolean;
  readonly captureUrlParams?: boolean;
  readonly captureCookies?: boolean;
  readonly customClickIdParams?: string[];
};

export const DEFAULT_ATTRIBUTION_CONFIG: AttributionConfig = {
  enabled: true,
  ttlDays: 90,
  persist: true,
  captureUrlParams: true,
  captureCookies: true,
  customClickIdParams: [],
};

export const ATTRIBUTION_STORAGE_KEY = 'attribution';

export interface AttributionService {
  init(): void;
  destroy(): void;
  collect(): AttributionIdentifiers;
  getSnapshot(): AttributionIdentifiers;
  update(partial: Partial<AttributionIdentifiers>): AttributionIdentifiers;
  clear(): void;
}
